module.exports = __webpack_public_path__ + "img/096.ab17410d.png";